import { initState } from './state';
import api from "../../../api";

export default {
	USER_LOGGED_IN(state, {user, source}) {
		state.user = user;
		state.source = !source ? 'cognito' : source;

		api.bangeo.getUser(user).then((response) => {
			if (!_.isEmpty(response.data.user)) {
				state.user = {
					...state.user,
					isRegoUser: true
				};
			}
		});
	},
	USER_LOGGED_OUT(state) {
		// state.user = null;
		Object.assign(state, initState());
	},
	UPDATE_USER_DATA(state, {userData, source}) {
		state.user = {
			...state.user,
			...userData
		};

		api.bangeo.getUser(state.user).then((response) => {
			if (!_.isEmpty(response.data.user)) {
				state.user = {
					...state.user,
					isRegoUser: true
				};
			}
		});

		if (source) {
			state.source = source;
		}
	},
	UPDATE_USER_DATA_ONLY(state, {userData}) {
		state.user = {
			...state.user,
			...userData
		};
	}
};